import React, { useEffect, useMemo, useState } from "react";
import { getPageTypes } from "common/services/analytics.service";
import { normalize } from "common/lib/normalize";
import { FilterValueSelect } from "Components/Common/TableFilters";

type PageTypeFilterProps = {
  onChange: (value: any) => void;
  value: any;
  isLTA?: boolean;
};

const PageTypeFilter = ({ onChange, value, isLTA }: PageTypeFilterProps) => {
  const [loading, setLoading] = useState(false);

  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await getPageTypes({
          pagination: {
            page: 1,
            pageSize: 10000,
          },
        });

        setData(normalize(response.data));
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [setLoading]);

  const options = useMemo(() => {
    return data.map((el: any) => {
      return {
        value: el?.id,
        label: el?.name,
      };
    });
  }, [data]);

  return (
    <FilterValueSelect
      id="pageTypeFilter"
      placeholder="Select Page Type"
      value={value}
      onChange={onChange}
      options={options}
      isLoading={loading}
    />
  );
};

export default PageTypeFilter;
